module.exports = __webpack_public_path__ + "static/media/innoTerminal.1db9662b.png";